module.exports = __webpack_public_path__ + "static/img/bofang2.cd151e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/bofang2.png
// module id = tbLV
// module chunks = 24